export default __webpack_public_path__ + "static/media/9.8a3d0447.png";